import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseApiService } from './api/base-api.service';

@NgModule({
  imports: [CommonModule],
  providers: [BaseApiService],
})
export class SharedDataAccessModule {}
